import { render, staticRenderFns } from "./ToolRoom.vue?vue&type=template&id=45b1160c&scoped=true&"
import script from "./ToolRoom.vue?vue&type=script&lang=js&"
export * from "./ToolRoom.vue?vue&type=script&lang=js&"
import style0 from "./ToolRoom.vue?vue&type=style&index=0&id=45b1160c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b1160c",
  null
  
)

export default component.exports